// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const Heading4IconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="Heading4Icon" ref={forwardedRef} {...props}>
      <path d="M1.75 4.5h1.527V16H1.75zm.793 4.95h6.22v1.478h-6.22zM8.078 4.5h1.527V16H8.078z" />
      <path d="m16.191 12.981.02-.462V6.75l.05-.873-3.512 6.11h6.001v1.375l-7.568.031v-1.448l4.315-7.393h2.241V16h-1.537v-3.019z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const Heading4Icon = /* @__PURE__ */ Object.assign(
  Heading4IconComponent,
  { displayName: 'Heading4Icon' },
);
